import React from 'react';

/**
 * Tag visual indicando o ESCOPO de um widget do dashboard admin.
 * Ajuda o usuário a entender quais cards/seções respeitam o filtro
 * de período / extensão / curso e quais são snapshots fixos.
 *
 * Variantes:
 *   periodo  → respeita filtros de período e extensão (laranja)
 *   geral    → snapshot atual, não muda com filtro de período (cinza)
 *   extensao → muda apenas com filtro de extensão (azul)
 *   fixo     → independe de qualquer filtro (cinza) — útil para alertas,
 *              listas de "últimos N" e gráficos com janela fixa (ex: 12m)
 *
 * `label` permite sobrescrever o texto padrão (ex: "últimos 10",
 * "sempre 12 meses").
 */
const EscopoBadge = ({ escopo = 'geral', label }) => {
  const presets = {
    periodo:  { label: 'no período',   cor: 'bg-orange-50 text-orange-700 border-orange-200', title: 'Respeita os filtros de período e de extensão.' },
    geral:    { label: 'geral',        cor: 'bg-gray-100 text-gray-600 border-gray-200',     title: 'Total atual — não muda com o filtro de período.' },
    extensao: { label: 'por extensão', cor: 'bg-blue-50 text-blue-700 border-blue-200',     title: 'Muda apenas com o filtro de extensão.' },
    fixo:     { label: 'sempre',       cor: 'bg-gray-100 text-gray-600 border-gray-200',     title: 'Não é afetado pelos filtros.' },
  };
  const cfg = presets[escopo] || presets.geral;
  return (
    <span
      className={`inline-block text-[10px] px-1.5 py-0.5 border rounded ${cfg.cor}`}
      title={cfg.title}
    >
      {label || cfg.label}
    </span>
  );
};

export default EscopoBadge;
